import React from 'react';
import { Typography } from '@mui/material';
import SynergySettings from './SynergySettings';
import HostingServersSettings from './HostingServersSettings';

/** Settings > Integrations: API credentials for external services. Secrets are encrypted and never shown again. */
const IntegrationsTab: React.FC = () => (
  <>
    <Typography variant="body2" color="text.secondary">
      API IDs, keys and tokens for the services SonOps connects to. Secrets are encrypted when saved and can't be
      viewed again.
    </Typography>
    <SynergySettings />
    <HostingServersSettings />
  </>
);

export default IntegrationsTab;
